// Boost.js - How power-ups look

export const drawBoost = (ctx, boost, boostImages) => {
  if (boost.collected) return;
  
  // All boosts now use images only - no backgrounds!
  
  // Rocket - larger size
  if (boost.type === 'rocket') {
    if (boostImages && boostImages.boostRocket) {
      const rocketWidth = boost.w * 1.3;
      const rocketHeight = boost.h * 1.1;
      const offsetX = (boost.w - rocketWidth) / 2;
      const offsetY = (boost.h - rocketHeight) / 2;
      ctx.drawImage(boostImages.boostRocket, boost.x + offsetX, boost.y + offsetY, rocketWidth, rocketHeight);
    } else {
      ctx.fillText('🚀', boost.x + boost.w/2, boost.y + boost.h/2);
    }
    return;
  }
  
  // Slowmo - 30% bigger
if (boost.type === 'slowmo') {
  if (boostImages && boostImages.boostSlowmo) {
    const slowmoSize = boost.w * 1.5;
    const offset = (boost.w - slowmoSize) / 2;
    ctx.drawImage(boostImages.boostSlowmo, boost.x + offset, boost.y + offset, slowmoSize, slowmoSize);
  } else {
    ctx.fillText('🌀', boost.x + boost.w/2, boost.y + boost.h/2);
  }
  return;
}

// Magnet - 30% bigger
if (boost.type === 'magnet') {
  if (boostImages && boostImages.boostMagnet) {
    const magnetSize = boost.w * 1.4;
    const offset = (boost.w - magnetSize) / 2;
    ctx.drawImage(boostImages.boostMagnet, boost.x + offset, boost.y + offset, magnetSize, magnetSize);
  } else {
    ctx.fillText('🧲', boost.x + boost.w/2, boost.y + boost.h/2);
  }
  return;
}
  
  // Shield - stretched vertically by 10%
if (boost.type === 'shield') {
  if (boostImages && boostImages.boostShield) {
    const shieldWidth = boost.w;
    const shieldHeight = boost.h * 1.1; // 10% taller
    const offsetY = (boost.h - shieldHeight) / 2;
    ctx.drawImage(boostImages.boostShield, boost.x, boost.y + offsetY, shieldWidth, shieldHeight);
  } else {
    ctx.fillText('🛡️', boost.x + boost.w/2, boost.y + boost.h/2);
  }
  return;
}
  
  // Shooter - taller to maintain aspect ratio
if (boost.type === 'shooter') {
  if (boostImages && boostImages.boostShooter) {
    const shooterWidth = boost.w*0.9; // Slightly narrower
    const shooterHeight = boost.h * 1.2; // 20% taller
    const offsetY = (boost.h - shooterHeight) / 2;
    ctx.drawImage(boostImages.boostShooter, boost.x, boost.y + offsetY, shooterWidth, shooterHeight);
  } else {
    ctx.fillText('🔫', boost.x + boost.w/2, boost.y + boost.h/2);
  }
  return;
}
  
  // Double Points - normal size
  if (boost.type === 'doublePoints') {
    if (boostImages && boostImages.boostDoublePoints) {
      ctx.drawImage(boostImages.boostDoublePoints, boost.x, boost.y, boost.w, boost.h);
    } else {
      ctx.fillText('💎', boost.x + boost.w/2, boost.y + boost.h/2);
    }
    return;
  }
};

export const drawAllBoosts = (ctx, boosts, boostImages) => {
  boosts.forEach(boost => {
    drawBoost(ctx, boost, boostImages);
  });
};